import {
  getFirestore,
  collection,
  query,
  where,
  getDocs,
  orderBy,
} from "firebase/firestore";
import filtrarDatos from "../functions/filtrarDatos";
import Swal from 'sweetalert2'
const db = getFirestore();

async function filtrarDocumentos(stringBusqueda, dni, ano, baseDatos, ruc) {
  // Convertir año a número si es uploadDocument
  const anoFinal = stringBusqueda === 'reciboHonorarios' ? 
    (typeof ano === 'string' ? parseInt(ano) : ano) : 
    ano;

  const usuarioFiltrado = await filtrarDatos(dni, "users", ruc);
  let DNIFiltrado;

  if(usuarioFiltrado===null){
    Swal.fire({
      position: 'center',
      icon: 'error',
      title: 'No tiene autorización para ver esta información',
      showConfirmButton: false,
      timer: 2000
    })
    DNIFiltrado=0;
  } else {
    DNIFiltrado = dni
  }

  const docusFiltrado = [];
  const collecionRef = collection(db, baseDatos);
  
// Ordenar por mes si es reciboHonorarios o ConstanciaFirma, sino por periodo
const orderByField = (stringBusqueda === 'reciboHonorarios' || stringBusqueda === 'ConstanciaFirma')
  ? 'mes'
  : 'periodo';
  
  const queryTitulo = query(
    collecionRef,
    where("tipo", "==", stringBusqueda),
    where("dni", "==", DNIFiltrado),
    where("ano", "==", anoFinal),
    orderBy(orderByField, "asc")
  );

  const arraySnapshots = await Promise.all([
    getDocs(queryTitulo),
  ]);

  arraySnapshots.forEach((snapshot) => {
    snapshot.forEach((doc) => {
      const data = doc.data();
      // ¡AGREGAR EL ID DEL DOCUMENTO!
      data.id = doc.id;
      docusFiltrado.push(data);
    });
  });
  return docusFiltrado;
}

export default filtrarDocumentos;